import createSerializeDeserialize from '@exodus/serialization';
// eslint-disable-next-line @exodus/restricted-imports/prefer-basic-utils
import { keyBy } from 'lodash';
import pDefer from 'p-defer';
const { deserialize: deserializePublicKey } = createSerializeDeserialize();
export class PublicKeyProvider {
    #assetsModule;
    #publicKeysCacheAtom;
    #deferredFetch = pDefer();
    constructor({ assetsModule, publicKeysCacheAtom }) {
        this.#assetsModule = assetsModule;
        this.#publicKeysCacheAtom = publicKeysCacheAtom;
    }
    #getCache = async () => {
        let cache = await this.#publicKeysCacheAtom.get();
        if (!cache) {
            // If atom is not populated, it means we need to wait for `fetch` to run.
            await this.#deferredFetch.promise;
            cache = await this.#publicKeysCacheAtom.get();
        }
        return cache;
    };
    #getCacheKey = ({ derivationPath, derivationAlgorithm, keyType }) => `${derivationPath}-${derivationAlgorithm}-${keyType}`;
    load = async (publicKeys) => {
        const deserializedPublicKeys = publicKeys.map((publicKey) => ({
            ...publicKey,
            publicKey: deserializePublicKey(publicKey.publicKey),
        }));
        await this.#publicKeysCacheAtom.set(keyBy(deserializedPublicKeys, 'key'));
        this.#deferredFetch.resolve();
    };
    getPublicKey = async ({ keyIdentifier }) => {
        const cache = await this.#getCache();
        const cacheKey = this.#getCacheKey(keyIdentifier);
        const { publicKey } = cache[cacheKey] ?? {};
        return publicKey;
    };
    getSupportedPurposes = (opts) => {
        const { baseAsset } = this.#assetsModule.getAsset(opts.assetName);
        return baseAsset.api?.getSupportedPurposes(opts);
    };
}
const PublicKeyProviderModuleDefinition = {
    id: 'publicKeyProvider',
    type: 'module',
    factory: (args) => new PublicKeyProvider(args),
    public: true,
    dependencies: ['assetsModule', 'publicKeysCacheAtom'],
};
export default PublicKeyProviderModuleDefinition;
